module.exports = __webpack_public_path__ + "img/delta-slow-queries.a39157e0.png";